import { createSlice } from '@reduxjs/toolkit';
import { deserialize } from 'deserialize-json-api';
// utils
import axios from "../../../utils/axios";
import { dispatch } from '../../store';

const initialState = {
    isLoading: false,
    weeklyHQPackageOverview: []
}

const slice = createSlice({
    name: 'Weekly HQ Package Overview',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // STOP LOADING
        stopLoading(state) {
            state.isLoading = false;
        },

        // Success Deliveries
        getWeeklyHQPackageOverviewSuccess(state, action) {
            state.isLoading = false;
            state.weeklyHQPackageOverview = action.payload.data;
        }
    }
});

// reducers
export default slice.reducer;


export function getWeeklyHQPackageOverview(period) {
    return async () => {
        try {
            let pathName = `/retailer_app/api/v1/retailers/metrics?period=${encodeURIComponent(period ? period : 'This Week')}`
            const response = await axios.get(pathName);
            const data = deserialize(response.data, { transformKeys: 'camelCase' });
            dispatch(slice.actions.getWeeklyHQPackageOverviewSuccess(data));
        } catch (error) {
            console.error('Error fetching retailer customers:', error);
            throw error;
        }

    }
}